export const LOAN_ERROR_CODE = {
    100603: 'loan_accont_assets_tip', // 账户余额不足
    100604: 'loan_exceed_pledge_rate_tip', // 风险率校验不通过，超出预警质押线
    100605: 'loan_max_amount_tip', // 借款额度超过上限
    100606: 'loan_min_amount_tip', // 借款额度低于下限
    100607: 'loan_max_pledge_tip', // 质押额度超过上限
    100608: 'loan_min_pledge_amount_tip', // 质押额度低于下限
    100619: 'loan_uta_tip1', // UTA&&升级资金账户用户禁止借贷
    100618: 'loan_uta_tip2', // UTA升级中禁止借贷
    100620: 'loan_max_amount_tip2', // 用户借贷额度不足
    100621: 'loan_amount_less_tip', // 平台借贷额度不足
    100622: 'loan_max_pledge_tip2', // 用户质押额度不足
    100623: 'loan_amount_pledge_less_tip', // 平台质押额度不足
};

export const REAPY_ERROR_CODE = {
    200101: 'loan_accont_assets_tip', // 余额不足
    200103: 'loan_repay_more_tip', // 请不要超额还款
    200104: 'loan_covering_position_tip', // 补仓中，不允许还款
    200105: 'loan_interest_accruing_tip', // 计息中，不允许还款
    200106: 'loan_liquidate_tip', // 强平中，不允许还款
    200114: 'loan_uta_tip5', // UTA升级中无法还款
};

export const PLEDGE_RATE_ERROR_CODE = {
    999989: 'loan_accont_assets_tip', // 余额不足
    300001: 'loan_liquidate_pledge_tip', // 强平中，不允许调整质押金
    300008: 'loan_uta_tip3', // UTA&&升级资金账户用户无法调整质押金
    300007: 'loan_uta_tip4', // UTA升级中无法调整质押金
    200005: 'AdjustLoanFail', // 质押资产调整失败, 请重试
    300009: 'ReduceLoanTip3', // 不能减少质押资产,  减少的数量需小于质押资产可减数量, 请重试
    100615: 'reachedAccountLimit', // 达到了用户限额
    100614: 'reachedPlatformLimit', // 达到了平台限额
};
